import { Loader2 } from "lucide-react"
import { Skeleton } from "./skeleton.tsx"
import { TextShimmer } from "./text-shimmer.tsx"
import { useEffect, useState } from "react"

const ImageLoader = () => {
  const [loadingValue, setLoadingValue] = useState(0)

  useEffect(() => {
    const duration = 50000; // 50 seconds
    const targetValue = 97;
    const stepTime = 100; // Update every 100ms
    const stepIncrease = targetValue / (duration / stepTime);

    const interval = setInterval(() => {
      setLoadingValue((prev) => {
        const nextValue = prev + stepIncrease;
        return nextValue >= targetValue ? targetValue : nextValue;
      });
    }, stepTime);

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      <TextShimmer className='ps-2 font-poppins text-sm' duration={1.3}>
        Generating new image...
      </TextShimmer>
      <Skeleton className="w-full aspect-[3/2] flex flex-col items-center gap-2 justify-center">
        <Loader2 className="animate-spin" />
        <p className="text-xs">{Math.floor(loadingValue)}%</p>
      </Skeleton>
    </>
  )
}

export default ImageLoader
